import TagManager from "@sooro-io/react-gtm-module"
import config from "@/config"

const tagManagerEnabled =
  config.GOOGLE_TAG_MANAGER_ID !== "" && typeof window !== "undefined"

if (tagManagerEnabled) {
  TagManager.initialize({ gtmId: config.GOOGLE_TAG_MANAGER_ID })
}

export const useTagManager = () => {
  return tagManagerEnabled ? TagManager : undefined
}
